<template>
	<div class="ht-profile-user-bids">
		<Loading :active.sync="loading"></Loading>
		<h3 class="title">{{ $t('Products waiting for payment') }}</h3>
		<b-table :data="wonbids" hoverable :paginated="false" per-page="-1" detail-key="id">
			<template slot-scope="props">
				<b-table-column field="id" :label="$t('SKU')">{{ props.row.Product.sku }}</b-table-column>
				<b-table-column field="name" :label="$t('Product name')">
					<a v-bind:href="'/product/' + props.row.id" target="_blank">{{ props.row.Product.name }}</a>
				</b-table-column>
				<b-table-column field="price" :numeric="true" :label="$t('Buyout price')">{{
					props.row.price | toUserCurrency($data._this)
				}}</b-table-column>
				<b-table-column field="commission" :numeric="true" :label="$t('Commission') + ' (' + commission + '%)'">{{
					props.row.commission | toUserCurrency($data._this)
				}}</b-table-column>
				<b-table-column field="price_with_commission" :numeric="true" :label="$t('Total')">
					<span v-on:click="$root.$emit('changeTab', 3)" :title="$t('Unpaid Product')">{{
						props.row.price_with_commission | toUserCurrency($data._this)
					}}</span>
				</b-table-column>
				<b-table-column>
					<b-tooltip :label="$t('Unpaid Product')">
						<b-icon size="is-small" custom-class="pt-half" icon="exclamation"></b-icon>
					</b-tooltip>
				</b-table-column>
			</template>
			<template slot="footer">
				<td colspan="2">
					<span class="has-text-left">
						<h2 class="has-text-danger subtitle">
							{{ $t('Amount') }}:&nbsp;{{ total_all | toUserCurrency($data._this) }}
						</h2>
					</span>
				</td>
				<td class="has-text-right">
					<strong>{{ total | toUserCurrency($data._this) }}</strong>
				</td>
				<td class="has-text-right">
					<strong>{{ total_commission | toUserCurrency($data._this) }}</strong>
				</td>
				<td class="has-text-right">
					<strong>{{ total_all | toUserCurrency($data._this) }}</strong>
				</td>
				<td></td>
			</template>
		</b-table>
		<div class="summary-paybox">
			<hr>
			<nav class="level">
				<div class="level-item has-text-centered" v-if="wonbids.length > 0">
					<b-button
						:disabled="total == 0 || pay_started == true"
						type="is-primary"
						outlined
						icon-left="cash-register"
						@click="callback(total_all, product_post_price, wonbids)"
						>{{ $t('Continue to checkout') }}</b-button
					>
				</div>
			</nav>
		</div>
		<h3 class="title">{{ $t('Paid Products') }}</h3>
		<b-table :data="oldbids" hoverable :paginated="true" per-page="10" detail-key="id">
			<template slot-scope="props">
				<b-table-column field="id" :label="$t('SKU')">{{ props.row.Product.sku }}</b-table-column>
				<b-table-column field="name" :label="$t('Product name')">
					<a v-bind:href="'/product/' + props.row.id" target="_blank">{{ props.row.Product.name }}</a>
				</b-table-column>
				<b-table-column field="price" :numeric="true" :label="$t('Buyout price')">{{
					props.row.price | toUserCurrency($data._this)
				}}</b-table-column>
				<b-table-column field="commission" :numeric="true" :label="$t('Commission') + ' (' + commission + '%)'">{{
					props.row.commission | toUserCurrency($data._this)
				}}</b-table-column>
				<b-table-column field="price_with_commission" :numeric="true" :label="$t('Total')">{{
					props.row.price_with_commission | toUserCurrency($data._this)
				}}</b-table-column>
			</template>
		</b-table>
	</div>
</template>

<script>
import Loading from 'vue-loading-overlay'

export default {
	components: {
		Loading,
	},
	data() {
		return {
			loading: true,
			wonbids: [],
			oldbids: [],
			showDetailsIcon: null,
			commission: 20,
			total: 0,
			total_commission: 0,
			total_all: 0,
			product_post_price: null,
			checkOutTotal: 0,
			// eslint-disable-next-line vue/no-reserved-keys
			_this: this,
			pay_started: false,
		}
	},
	props: {
		selectAuction: null,
		selectedTab: {
			type: Number,
			default: 0,
		},
		seller: {
			type: Boolean,
			default: false
		},
		winner: {
			type: Boolean,
			default: false
		},
		callback: null,
		refresh: null,
	},
	mounted() {
		console.log('USER', this.$store.getters.userpref)
		this.fetchList()
	},
	methods: {
		refreshTab() {
			console.log('X_X_X_X_X_X')
		},
		total_price: function (rows, _this) {
			_this.total = 0
			_this.total_commission = 0
			_this.total_all = 0
			Object.entries(rows).forEach(([value, index]) => {
				_this.total_all += index.price_with_commission
				_this.total += index.price
				_this.total_commission += index.commission
				if (index.Product.post_price > _this.product_post_price) {
					_this.product_post_price = index.Product.post_price
				}
			})
		},
		fetchList: function () {
			var _this = this
			_this.loading = true
			var path = '/won-bids/' + _this.selectAuction
			_this.$http.get(path).then((response) => {
				if (response.data.wonbids[0]) {
					_this.commission = response.data.wonbids[0].commission_percent
				}
				console.log('PAY STARTED', _this.pay_started)
				_this.wonbids = response.data.wonbids
				_this.oldbids = response.data.oldbids
				_this.loading = false
			})
		},
	},
	watch: {
		selectedTab: function (newVal) {
			if (newVal == 0) {
				this.fetchList()
			}
		},
		selectAuction: function () {
			console.log('won-bids')
			this.fetchList()
		},
		wonbids: function (newVal) {
			this.total_price(newVal, this)
			this.checkedRows = []
		},
		refresh: function () {
			if (this.selectedTab == 0) {
				this.fetchList()
			}
			this.$root.$emit('updateCart')
		},
	},
}
</script>
